import { inject } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { SystemDomainsApiService } from '../api/system-domains-api.service';

export const SYSTEM_DOMAINS_QUERY_KEY = ['system-domains'] as const;

export function injectSystemDomainsQuery() {
    const api = inject(SystemDomainsApiService);

    return injectQuery(() => ({
        queryKey: SYSTEM_DOMAINS_QUERY_KEY,
        queryFn: () => lastValueFrom(api.getSystemDomains()),
        staleTime: 5 * 60 * 1000,
    }));
}
